import { t } from "i18next";
import {
  CoffeeIcon,
  UsersIcon,
  HeartIcon,
  ListIcon,
  BusinessIcon,
  OtherIcon,
} from "@/shared/icons";
import type { MenuItem } from "./types";

export const CONTACTS_FILTERS_MENU_ITEMS: MenuItem[] = [
  {
    key: 1,
    icon: <ListIcon />,
    label: t("contactsPage.groups.all"),
    onClick: () => "",
  },
  {
    key: 2,
    icon: <HeartIcon />,
    label: t("contactsPage.groups.family"),
    onClick: () => "",
  },
  {
    key: 3,
    icon: <CoffeeIcon />,
    label: t("contactsPage.groups.friends"),
    onClick: () => "",
  },
  {
    key: 4,
    icon: <UsersIcon />,
    label: t("contactsPage.groups.colleagues"),
    onClick: () => "",
  },
  {
    key: 5,
    icon: <BusinessIcon />,
    label: t("contactsPage.groups.business"),
    onClick: () => "",
  },
  {
    key: 6,
    icon: <OtherIcon />,
    label: t("contactsPage.groups.other"),
    onClick: () => "",
  },
];
